import React, { useState } from "react";
import "../styles.css";
import { ConfigProvider } from "antd"
import { getPrimaryAccent } from "./UserSettings";

import OverviewFlow from "./Flow";
import Header  from "./Header";
import Settings from "./Settings";

import { getSettingsMenu } from "./UserSettings";

/*Top level component
  Logic here handles importing, creating new networks etc.

  *Unlikely to need editing*
*/



// TODO For whatever reason when the total height exceeds 99.4% there's a scrollbar.
const headerHeight = "50px";


//forceUpdate Hook is used to force a rerender of the app component
export function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
}

let refreshNodes = false;
export function setRefreshNodes() {refreshNodes = !refreshNodes;}
export function getRefreshNodes() {return refreshNodes;}


let settingsVisible = false;
let importNodes = [];
let importEdges = [];
export let newNet = false;
function App() {
    const forceUpdate = useForceUpdate();

    function setImport(ns, es) {
        importNodes = ns;
        importEdges = es;
        forceUpdate();
    }

    function setNewNet() {
        newNet = true;
        forceUpdate();
    }
    
    let originalSettings = getSettingsMenu();
    function openCloseSettings() {
      originalSettings = getSettingsMenu();
      settingsVisible = !settingsVisible;
      forceUpdate();

      //Janky way to fix graphical issue with active key in antd menu
      let counter = 0;
      let interval = setInterval(function(){
        counter += 1;
        if(counter === 20){clearInterval(interval);}
          let elementsToChange = document.getElementsByClassName("ant-menu-overflow-item ant-menu-item ant-menu-item-active");
          for (let i = 0; i < elementsToChange.length; i++) {elementsToChange[i].className = ("ant-menu-overflow-item ant-menu-item");}
      }, 50); 
    }
    
    return (
        <ConfigProvider
        theme={{
          token: {
            colorPrimary: getPrimaryAccent()
          },
        }}
        >
        <div style={{height:"100%"}}>
          <div style={{height: headerHeight}}><Header setImport={setImport} setNewNet={setNewNet} openCloseSettings={openCloseSettings} forceUpdateApp={forceUpdate}/></div>
          <div style={{display: "grid", gridTemplateColumns: "100%", height: 'calc(100% - ' + headerHeight + ')'}}>
            <OverviewFlow importNodes={importNodes} importEdges={importEdges} setImport={setImport}/>
          </div>
          <Settings visible={settingsVisible} openClose={openCloseSettings} originalSettings={originalSettings} />
        </div>
        </ConfigProvider>
    );
}

export default App;
